import Vue from 'vue'
import PrimaryNav from './primary-nav'
import Carousel from './carousel'
import Accordion from './accordion'
import MicrochipChecker from './microchip-checker'
import RegistrationForm from './registration-form'
import RegistrationReports from './registration-reports'
import UpdateCompanionAnimalForm from './update-companion-animal-form'
import ViewCompanionAnimal from './view-companion-animal'
import SearchTable from './search-table'
import UpdateLostStatus from './update-lost-status'
import UploadProfileImage from './upload-profile-image'
import MarkAsDeceased from './mark-as-deceased'
import TransferPet from './transfer-pet'
import VueFinalModal from 'vue-final-modal/lib'
import Toast from 'vue-toastification'
import ToastOnLoad from './toast-on-load'
import VTooltip from 'v-tooltip'
import FlashBanner from './flash-banner'
import PrintPreview from './print-preview'
import LostPetForm from './lost-pet-form'
import LostPetPreviewForm from './lost-pet-preview-form'
import MyLostPetTable from './my-lostpet-table'
import LostpetSearchTable from './lost-pet-search-table'
import LostPetListings from './lost-pet-listings'
import LostPetUploadImage from './lost-pet-upload-image'
import LostPetSearchControls from './lost-pet-search-controls'

// Tooltip plugin https://github.com/Akryum/v-tooltip.
Vue.use(VTooltip, {
  defaultTrigger: 'hover click',
})

// Modal plugin (used across multiple components)
Vue.use(VueFinalModal())

/**
 * Toast component config.
 * See themes/default/js/toast/index.js for usage
 */
Vue.use(Toast, {
  timeout: 20000,
  icon: false,
  position: 'bottom-right',
  closeButton: false,
  draggablePercent: 0.2,
  toastClassName: 'c-toast-container',
  bodyClassName: 'c-toast-container__inner',
})
Vue.config.errorHandler = function (err, vm, info) {
  window.rg4js('send', {
    error: err,
    customData: [{ info: info }],
  })
}

new Vue({
  // eslint-disable-line
  el: '#vue-root',
  components: {
    PrimaryNav,
    Carousel,
    Accordion,
    MicrochipChecker,
    RegistrationForm,
    RegistrationReports,
    SearchTable,
    UpdateCompanionAnimalForm,
    ViewCompanionAnimal,
    UpdateLostStatus,
    MarkAsDeceased,
    TransferPet,
    ToastOnLoad,
    UploadProfileImage,
    FlashBanner,
    PrintPreview,
    LostPetForm,
    LostPetPreviewForm,
    MyLostPetTable,
    LostpetSearchTable,
    LostPetUploadImage,
    LostPetSearchControls,
    LostPetListings,
  },
  data() {
    return {
      // Used to pass state between components on the Guardian's CA update page
      transferPending: false,
    }
  },
})
